var testi_carousels = document.querySelectorAll(".testimonials--body.swiper-container");

testi_carousels.forEach((carou) => {
  new Swiper(carou, {
    // Optional parameters
    direction: "horizontal",
    slidesPerView: 3,
    speed: 1000,
    spaceBetween: 25,
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      800: {
        slidesPerView: 2,
      },
      1300: {
        slidesPerView: 2,
      },
      1441: {
        slidesPerView: 3,
      }
    },

    // Navigation arrows
    navigation: {
      nextEl: `.swiper-button-next-${carou.getAttribute("data-id")}`,
      prevEl: `.swiper-button-prev-${carou.getAttribute("data-id")}`,
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
});


var ingredients_carousel = document.querySelectorAll(".ingredients--body.swiper-container");

ingredients_carousel.forEach((carou) => {
  new Swiper(carou, {
    // Optional parameters
    direction: "horizontal",
    slidesPerView: 3,
    speed: 1000,
    spaceBetween: 12,
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      600: {
        slidesPerView: 2,
      },
      1441: {
        slidesPerView: 3,
      }
    },

    // Navigation arrows
    navigation: {
      nextEl: `.swiper-button-next-${carou.getAttribute("data-id")}`,
      prevEl: `.swiper-button-prev-${carou.getAttribute("data-id")}`,
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
});